<!-- LOADING -->
<app-loading [hidden]="!loading"></app-loading>

<!-- CONTEÚDO -->
<ng-container *ngIf="viewModules$ | async as vm">
    <div *ngIf="!loading" class="flex justify-center">

        <!-- FORMULÁRIO -->
        <div class="w-full max-w-[624px]">
            <form [formGroup]="patientForm" (ngSubmit)="onSubmit()">

                <!-- DADOS OBRIGATÓRIOS -->
                <div class="border-b pb-4">
                    <p class="font-medium text-base text-westetics-neutral-950">
                        Dados Obrigatórios*
                    </p>
                    <p class="text-sm text-westetics-neutral-800 mt-2">
                        Informe os dados obrigatórios
                    </p>
                </div>

                <!-- Nome do Paciente -->
                <div class="border-b pb-4 mt-4">
                    <label for="name" class="block mb-2 text-sm font-medium text-westetics-neutral-950">
                        Nome do {{vm.moduleNameInSingular}}*
                    </label>
                    <input type="text" id="name" formControlName="name"
                        [placeholder]="'Insira o nome do ' + vm.moduleNameInSingular"
                        class="bg-gray-50 border border-gray-300 text-neutral-500 text-sm rounded-lg outline-none focus:ring-westetics-purple-800 focus:border-westetics-purple-800 block w-full p-2.5"
                        [ngClass]="{'border-red-500': patientForm.get('name')?.invalid && patientForm.get('name')?.touched}" />
                    <span class="text-red-600 text-sm"
                        *ngIf="patientForm.get('name')?.invalid && patientForm.get('name')?.touched">
                        Insira um nome válido.
                    </span>
                </div>

                <!-- Botões -->
                <div class="flex justify-between my-6">
                    <button type="button" (click)="onCancel()"
                        class="w-[48%] py-[10px] text-westetics-purple-800 hover:text-white border-westetics-purple-800 hover:bg-westetics-purple-800 rounded-lg border">
                        Cancelar
                    </button>
                    <button type="submit"
                        class="w-[48%] py-[10px] bg-westetics-purple-800 hover:bg-westetics-purple-600 text-white rounded-lg">
                        Cadastrar
                    </button>
                </div>
            </form>
        </div>
    </div>
</ng-container>